/**
 * Module dependencies.
 */

import { resolveAppUrl } from 'app/core/utils/url-resolver';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useRequestProvider } from 'app/components/providers/request-provider/request-provider';

/**
 * Export `useUpdatePassword`.
 *
 * Sets (or resets) the current user's password (`POST /me/password`). The
 * endpoint responds silently; the caller shows its own confirmation toast.
 * Setting a password flips the auth method to `password`, so refresh `me`.
 */

export function useUpdatePassword() {
  const client = useRequestProvider();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (password: string) =>
      client.post(resolveAppUrl('updatePassword'), { password }).then(({ data }: { data: any }) => data),
    onSuccess: () => {
      queryClient.invalidateQueries(['me']);
    }
  });
}
